import { HeadsetMic } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#16a34a" icon={<HeadsetMic />} title="Atendente" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={`${classes.slot} ${classes.ellipsis}`}>{data.user.name}</div>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
